"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marano-sul-panaro": {
    "92e298e7": [{
      "hkey": "d6a56bf0",
      "slug": "ca-bernabei-villabianca",
      "name": "Ca' Bernabei-Villabianca",
      "primary": true,
      "skipSearch": false
    }],
    "ca-bernabei": [{
      "hkey": "d6a56bf0",
      "slug": "ca-bernabei-villabianca",
      "name": "Ca' Bernabei-Villabianca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "954f5575": [{
      "hkey": "6705608c",
      "slug": "casona-osteria-vecchia",
      "name": "Casona-Osteria Vecchia",
      "primary": true,
      "skipSearch": false
    }],
    "casona": [{
      "hkey": "6705608c",
      "slug": "casona-osteria-vecchia",
      "name": "Casona-Osteria Vecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "605ce375": [{
      "hkey": "6384e38f",
      "slug": "marano-sul-panaro",
      "name": "Marano sul Panaro",
      "primary": true,
      "skipSearch": false
    }],
    "denzano": [{
      "hkey": "6384e38f",
      "slug": "marano-sul-panaro",
      "name": "Marano sul Panaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8329d422": [{
      "hkey": "6705608c",
      "slug": "casona-osteria-vecchia",
      "name": "Casona-Osteria Vecchia",
      "primary": true,
      "skipSearch": false
    }],
    "osteria-vecchia": [{
      "hkey": "6705608c",
      "slug": "casona-osteria-vecchia",
      "name": "Casona-Osteria Vecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marano-sul-panaro"
    }],
    "8d27c318": [{
      "hkey": "6384e38f",
      "slug": "marano-sul-panaro",
      "name": "Marano sul Panaro",
      "primary": true,
      "skipSearch": false
    }],
    "spino": [{
      "hkey": "6384e38f",
      "slug": "marano-sul-panaro",
      "name": "Marano sul Panaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4489f23c": [{
      "hkey": "d6a56bf0",
      "slug": "ca-bernabei-villabianca",
      "name": "Ca' Bernabei-Villabianca",
      "primary": true,
      "skipSearch": false
    }],
    "villa-bianca": [{
      "hkey": "d6a56bf0",
      "slug": "ca-bernabei-villabianca",
      "name": "Ca' Bernabei-Villabianca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marano-sul-panaro"
    }]
  }
};
exports["default"] = _default;